import { JBaseApi } from '../base';
import { AnimationConfigurationType, AnimationStats, ApiWrapper, PagingResults } from '../../types';
import { OF } from '../../util';

export class JAnimationsApi extends JBaseApi {
    public async SaveAnimationConfiguration(animation: Object): Promise<ApiWrapper<AnimationConfigurationType>> {
        return this.network.post({
            o: 'animations',
            f: 'saveConfiguration',
            animation,
        } as OF);
    }

    public async DeleteAnimation(): Promise<ApiWrapper<boolean>> {
        return this.network.post({
            o: 'animations',
            f: 'deleteAnimation',
        } as OF);
    }

    public async GetCurrentAnimation(options?: {
        signal?: AbortSignal;
    }): Promise<ApiWrapper<AnimationConfigurationType | null>> {
        return this.network.post(
            {
                o: 'animations',
                f: 'getConfiguration',
            } as OF,
            options?.signal,
        );
    }

    public async GetCurrentAnimationApp(): Promise<ApiWrapper<AnimationConfigurationType | null>> {
        return this.network.post({
            o: 'animations',
            f: 'getConfigurationApp',
        } as OF);
    }

    public async ToggleAnimationActive(): Promise<ApiWrapper<boolean>> {
        return this.network.post({
            o: 'animations',
            f: 'toggleAnimationActive',
        } as OF);
    }

    public async GetAnimationActive(options?: { signal?: AbortSignal }): Promise<ApiWrapper<boolean>> {
        return this.network.post(
            {
                o: 'animations',
                f: 'getAnimationActive',
            } as OF,
            options?.signal,
        );
    }

    public async GetAnimationStats(name: string): Promise<ApiWrapper<PagingResults<AnimationStats>>> {
        return this.network.post({
            o: 'objectList',
            f: 'animationsStats',
            name,
        } as OF);
    }

    public async GetAnimationStatsCurrent(uri: string): Promise<ApiWrapper<AnimationStats>> {
        return this.network.post({
            o: 'objectList',
            f: 'animationsStatsCurrent',
            uri,
        } as OF);
    }
}
